"use client";

import { c as _c } from "react/compiler-runtime";
import { RelatedEntities as PostRelatedEntities } from "@/views/post/partials/RelatedEntities/RelatedEntities";
import { useLabels } from "@/lib/labels/LabelsProvider";
export type RelatedEntitiesVariant = "default" | "compact" | "minimal";
export interface RelatedEntitiesProps {
  /** Visual variant of the section */
  variant?: RelatedEntitiesVariant;
  /** Custom title override */
  title?: string;
  /** Maximum number of entities to display. When omitted, all entities are shown. */
  maxItems?: number;
  /** Custom container className */
  className?: string;
  /** Number of columns (1 for single column, undefined for responsive grid) */
  columns?: 1 | 2 | 3;
}

/**
 * RelatedEntities - Displays related entities (teams, players, competitions) from the article context.
 * Thin wrapper over post RelatedEntities that provides article-specific labels.
 */
export function RelatedEntities(props) {
  const $ = _c(3);
  const labels = useLabels();
  let t0;
  if ($[0] !== labels.articlePage.about || $[1] !== props) {
    t0 = <PostRelatedEntities {...props} aboutLabel={labels.articlePage.about} />;
    $[0] = labels.articlePage.about;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}